<template>
    <footer>
        <section class="section main">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="column-header">
                            <h1 class="title"><img src="@/assets/img/logo-black.png"/></h1>
                        </div>

                        <p>Una empresa comprometida con el medio ambiente y las futuras generaciones. Desde 2003 somos productores de hortalizas, frutas,  hierbas aromáticas y una gran variedad de productos de almacen de calidad.</p>
                    </div>

                    <div class="column">
                        <div class="column-header">
                            <h1 class="title">Contacto</h1>
                        </div>

                        <p>
                            <span class="icon is-medium is-left"><i class="fas fa-phone"></i></span>
                            0-800-88-TALLO
                        </p>

                        <p>

                        <p>
                            <span class="icon is-medium is-left"><i class="fab fa-lg fa-whatsapp"></i></span>
                            +54 911 6908-5320
                        </p>

                        <p>
                            <span class="icon is-medium is-left"><i class="fas fa-envelope"></i></span>
                            huerta@talloverde.com
                        </p>

                        <p>
                            <span class="icon is-medium is-left"><i class="fas fa-map"></i></span>
                            Ruta 192 Km. 8, Open Door, Luján
                        </p>
                    </div>

                    <div class="column">
                        <div class="column-header">
                            <h1 class="title">Seguinos</h1>
                        </div>

                        <p>Seguinos en nuestras redes sociales para enterarte de todas las novedades.</p>

                        <p>
                            <a class="social" href="https://www.facebook.com/talloverde/" target="_blank">
                                <span class="icon is-medium is-left"><i class="fab fa-lg fa-facebook-square"></i></span>
                                Facebook
                            </a>
                        </p>

                        <p>
                            <a class="social" href="https://www.instagram.com/talloverde.organico" target="_blank">
                                <span class="icon is-medium is-left"><i class="fab fa-lg fa-instagram"></i></span>
                                Instagram
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section copyright">
            <div class="container">
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <!-- <span><i class="far fa-copyright"></i> 2012-2018 Tallo Verde</span> -->
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <img class="footer-logo" src="@/assets/img/logo-oia.png"/>
                            <img class="footer-logo" src="@/assets/img/logo-organico-argentina.png"/>
                        </div>
                        <div class="level-item">
                            <a href="https://qr.afip.gob.ar/?qr=AEOXWOj-tYcOzgiIITwR_w,," target="_F960AFIPInfo">
                                <img class="footer-logo" src="https://www.afip.gob.ar/images/f960/DATAWEB.jpg" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
        components: {}
    }
</script>

<style lang="scss" scoped>
    footer {
        height: 300px;

        .main {
            font-size: 1.0em;
            background-color: #f9f8f4;
            color: #525252;

            .column-header {
                display: flex;
                height: 100px;
                justify-content: flex-start;
                align-items: flex-end;
                margin-bottom: 40px;

                .title {
                    font-size: 1em;
                    color: #525252;
                    text-transform: uppercase;
                }

                .title:after {
                    content: ' ';
                    width: 2.5em;
                    display: block;
                    margin: 0.5em 0 0;
                    border-bottom: 2px solid $primary;
                    text-align: left;
                }
            }
        }

        .copyright {
            padding: 1rem;
            background-color: #eeece5;

            .footer-logo {
                height: 80px;
            }
        }

        .social {
            color: #525252;
        }
    }
</style>